<script>
    // Logic
import createRouter from '@spaceavocado/svelte-router';
import RouterView from '@spaceavocado/svelte-router/component/view';
import {initApiData} from './utils/apiStore';
import { isBefore } from 'date-fns'

// Views
import ViewHome from './views/home.svelte';
import View404 from './views/404.svelte';
import ViewKommune from './views/kommune.svelte';

// Components
import Header from './components/Header.svelte';

initApiData();

createRouter({
    mode: 'HASH',
    routes: [{
            path: '/',
            name: 'Home',
            component: ViewHome
        },
        {
            path: '/kommune/:kommune',
            component: ViewKommune,
            props: (route) => {
                return {
                    kommunenavn: route.params.kommune
                }
            }
        },
        {
            path: '*',
            component: View404
        }
    ]
})
</script>

<div class="sa-app-container">
    <Header/>
        <div class="sa-app-content">
            <div class="page-content wide mt-0 disclaimer">
                <h1 class="page-content__title">Viktig</h1>
                <p class="page-content__ingress">Fra 23. mars 2022 opphørte SUS sin daglige rapportering av korona-pasienter på sykehuset. Tallene vil derfor ikke lenger oppdateres.</p>
                <p class="page-content__ingress mt-3">Smittetall oppdateres ikke lenger.</p>
            </div>
            <RouterView />
        </div>
        </div>

<style lang="scss">
.sa-app-content {
    margin-top: 1rem;
    .page-content__ingress > a {
        text-decoration: underline;
    }
}
</style>
